'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isIntersectionObserverSupported = exports.isIntersectionObserverSupported = function isIntersectionObserverSupported() {
  return typeof window !== 'undefined' && 'IntersectionObserver' in window;
};

var currentScrollPosition = exports.currentScrollPosition = function currentScrollPosition() {
  return {
    scrollX: window.scrollX || window.pageXOffset,
    scrollY: window.scrollY || window.pageYOffset
  };
};